import { Header2019, Header2019WithData } from './Header2019'
import AdminHeader, { AdminHeaderButton, AdminHeaderIconButton } from './AdminHeader'
import CFHeader from './CFHeader/CFHeader'
import LogoOnlyHeader from './LogoOnlyHeader'
import './locales'

/* istanbul ignore next */

export default Header2019WithData
export { Header2019, AdminHeader, AdminHeaderIconButton, AdminHeaderButton, CFHeader, LogoOnlyHeader }
